import { useMemo } from 'react';
import { debounce } from 'lodash';

// https://dmitripavlutin.com/react-throttle-debounce/
const useDebounce = (
  fn,
  delay = 750,
  {
    debounce: dOptions,
    useMemo: uMOptions,
  } = {
    debounce: {},
    useMemo: [],
  },
) =>
  useMemo(
    () =>
      debounce(
        fn,
        delay || dOptions.delay,
        dOptions,
      )
    , uMOptions,
  );

export default useDebounce;
